var React = require('react');

function ButtonArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.000976562 11.1729L22.9463 11.1384","stroke":"#4035C3","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M13.1616 1.27856L22.9995 11.1164L13.1616 20.9542","stroke":"#4035C3","strokeWidth":"1.5","key":1})]);
}

ButtonArrow.defaultProps = {"width":"25","height":"22","viewBox":"0 0 25 22","fill":"none"};

module.exports = ButtonArrow;

ButtonArrow.default = ButtonArrow;
